export default function ({ url }) {
  const fontLinkTag = document.createElement("link");
  fontLinkTag.type = "text/plain";
  fontLinkTag.dataset.cookiecategory = "analytics";
  fontLinkTag.sync = 1;
  fontLinkTag.crossOrigin = "anonymous";
  fontLinkTag.rel = "stylesheet";
  fontLinkTag.href = url;

  const firstLinkTag = document.getElementsByTagName("link")[0];
  firstLinkTag.parentNode.insertBefore(fontLinkTag, firstLinkTag);
}
